import { render, staticRenderFns } from "./cusReceivable.vue?vue&type=template&id=12e2598e&scoped=true&"
import script from "./cusReceivable.vue?vue&type=script&lang=js&"
export * from "./cusReceivable.vue?vue&type=script&lang=js&"
import style0 from "./cusReceivable.vue?vue&type=style&index=0&id=12e2598e&lang=less&scoped=true&"
import style1 from "./cusReceivable.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2598e",
  null
  
)

component.options.__file = "cusReceivable.vue"
export default component.exports